import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectCoverflow } from 'swiper/modules';
import { FaCalendarAlt, FaCheckCircle, FaTag, FaWhatsapp } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import './PromotionCarousel.css';
import clinicaConfig from "../../clinicaConfig.js";

const PromotionCarousel = ({ promotions }) => {
  const formatDate = (dateString) => {
    const datePart = dateString.substring(0, 10);
    const [year, month, day] = datePart.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('pt-BR');
  };

  const handleAgendarExames = (promotion) => {
    if (!promotion.exames || promotion.exames.length === 0) return;

    const examesTexto = promotion.exames
      .map((exame) => `- ${exame.nome}`)
      .join('\n');

    const mensagem = `Olá, desejo agendar a promoção "${promotion.nome}" com os seguintes exames:\n${examesTexto}\n\nTotal: R$ ${promotion.valorTotal.toFixed(2).replace('.', ',')}`;
    const mensagemCodificada = encodeURIComponent(mensagem);
    const numeroWhatsApp = clinicaConfig.whatsapp;

    const url = `https://wa.me/${numeroWhatsApp}?text=${mensagemCodificada}`;
    window.open(url, "_blank");
  };

  if (promotions.length === 1) {
    const promotion = promotions[0];
    return (
      <div className="promotion-carousel-wrapper">
        <div className="promo-carousel-single">
          <div className="promo-card-modern">
            <div className="promo-card-header">
              <div className="header-badges">
                <span className="modern-badge highlight">
                  <FaTag /> OFERTA ESPECIAL
                </span>
                <span className="modern-badge date">
                  <FaCalendarAlt /> Válido até {formatDate(promotion.dataFim)}
                </span>
              </div>
            </div>
            
            <div className="promo-card-body">
              <h2 className="promo-title-modern">{promotion.nome}</h2>
              
              <div className="promo-price-box">
                <span className="price-label">Promoção com {promotion.exames.length} exames</span>
                <div className="price-value-modern">R$ {promotion.valorTotal.toFixed(2).replace('.', ',')}</div>
              </div>

              <div className="exams-grid">
                <h4 className="exams-heading">Exames Inclusos</h4>
                <div className="exams-columns">
                  {promotion.exames.map((exame, index) => (
                    <div key={index} className="exam-item-modern">
                      <FaCheckCircle />
                      <span>{exame.nome}</span>
                    </div>
                  ))}
                </div>
              </div>

              <button onClick={() => handleAgendarExames(promotion)} className="btn-agendar-modern">
                <FaWhatsapp /> Agendar pelo WhatsApp
              </button>
            </div>

            <div className="promo-card-decoration">
              <div className="decoration-circle circle-1"></div>
              <div className="decoration-circle circle-2"></div>
              <div className="decoration-wave"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="promotion-carousel-wrapper">
      <Swiper
        modules={[Navigation, Pagination, Autoplay, EffectCoverflow]}
        effect="coverflow"
        grabCursor={true}
        centeredSlides={true}
        slidesPerView="auto"
        coverflowEffect={{
          rotate: 15,
          stretch: 0,
          depth: 200,
          modifier: 1,
          slideShadows: false
        }}
        navigation
        pagination={{ 
          clickable: true,
          dynamicBullets: true
        }}
        autoplay={{ 
          delay: 8000, 
          disableOnInteraction: false 
        }}
        loop={false}
        className="promo-swiper-modern"
      >
        {promotions.map((promotion, idx) => (
          <SwiperSlide key={promotion._id || idx} className="promo-slide-modern">
            <div className="promo-card-modern">
              <div className="promo-card-header">
                <div className="header-badges">
                  <span className="modern-badge highlight">
                    <FaTag /> OFERTA ESPECIAL
                  </span>
                  <span className="modern-badge date">
                    <FaCalendarAlt /> Válido até {formatDate(promotion.dataFim)}
                  </span>
                </div>
              </div>
              
              <div className="promo-card-body">
                <h2 className="promo-title-modern">{promotion.nome}</h2>
                
                <div className="promo-price-box">
                  <span className="price-label">Promoção com {promotion.exames.length} exames</span>
                  <div className="price-value-modern">R$ {promotion.valorTotal.toFixed(2).replace('.', ',')}</div>
                </div>

                <div className="exams-grid">
                  <h4 className="exams-heading">Exames Inclusos</h4>
                  <div className="exams-columns">
                    {promotion.exames.map((exame, index) => (
                      <div key={index} className="exam-item-modern">
                        <FaCheckCircle />
                        <span>{exame.nome}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <button onClick={() => handleAgendarExames(promotion)} className="btn-agendar-modern">
                  <FaWhatsapp /> Agendar pelo WhatsApp
                </button>
              </div>

              <div className="promo-card-decoration">
                <div className="decoration-circle circle-1"></div>
                <div className="decoration-circle circle-2"></div>
                <div className="decoration-wave"></div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default PromotionCarousel;
